import { boot } from 'quasar/wrappers'
import { FormDataPlugin } from '@formdata/vue'

// "async" is optional;
// more info on params: https://v2.quasar.dev/quasar-cli/boot-files
export default boot( ({ app, router }) => {
  app.use(FormDataPlugin)
})
